module.exports = __webpack_public_path__ + "static/media/018ty@2x.c7af2cae.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/018ty@2x.png
// module id = 1669
// module chunks = 0 1